import CRUDService from '../CRUDService';
import {HighSchoolAccountSettings} from 'src/views/high-school/account-settings/high-school-account-settings';
import {TransferAccountSettings} from 'src/views/transfer/AccountSettings/TransferAccountSettings';

class AccountSettingsService<T> extends CRUDService<T> {
  constructor() {
    super({baseUrl: '/v1/users'});
  }
}

export default new AccountSettingsService();

export const HighSchoolAccountSettingsService =
  new AccountSettingsService<HighSchoolAccountSettings>();

export const TransferAccountSettingsService = new AccountSettingsService<TransferAccountSettings>();
